// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac75ac6a","453":"b71bf42a","455":"35f56f90","644":"ab788283"}[chunkId] + ".chunk.js";
};